// Copyright (c) Move Closer 2022.

import { Component } from 'vue-property-decorator'

import { Inject } from '../../../support'
import { ProductData } from '../../../contexts'
import { ProductOrderData } from '../../../contexts/orders/contracts/orders'

import { IProductsRepository, ProductsRepositoryType } from '../../products/contracts/repositories'
import { ProductCartMixin } from '../../checkout/shared/mixins/product-cart.mixin'
import { RouteName as CheckoutRoutes } from '../../checkout/routes'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
@Component
export class RestoreOrderMixin extends ProductCartMixin {
  @Inject(ProductsRepositoryType)
  protected readonly productsRepository!: IProductsRepository

  public isLoading: boolean = false
  public isSuccessful: boolean = false

  /**
   * Create new cart from customer order data
   * @param products: ProductOrderData[]
   *
   * @author Filip Rurak <filip.rurak@movecloser.pl>
   */
  public async createNewCartFromOrder (products: ProductOrderData[]): Promise<void> {
    this.isLoading = true

    const skus: string[] = []
    for (const product of Object.values(products)) {
      skus.push(product.sku)
    }

    try {
      const productsResponse: ProductData[] = await this.productsRepository.loadProductsBySkus(skus)

      /** Collect all variants from productsResponse */
      const variants = []
      for (const item of Object.values(productsResponse)) {
        for (const variant of Object.values(item.variants)) {
          variants.push(variant)
        }
      }

      /**
       * 1/ Exclude variants that were not in customer order
       * 2/ Add each variant to the cart
       * 3/ Show toast after each successful action
       */
      const filteredVariants = variants.filter((item) => skus.includes((item.sku)))
      for (const item of Object.values(filteredVariants)) {
        await this.addToCart(item, 1, false)
        this.showToast(String(this.$t('front.shared.mixins.restoreOrderMixin.restoreSuccessInfo', { sku: item.sku })), 'info')
      }

      this.isSuccessful = true

      /** Redirect user to the cart */
      await this.$router.push({ name: `checkout.${CheckoutRoutes.Cart}` })
    } catch (e) {
      this.showToast((e as Error).message, 'warning')
    } finally {
      this.isLoading = false
    }
  }
}
